<cdk-virtual-scroll-viewport #viewport itemSize="31" minBufferPx="1000" maxBufferPx="2000" class="h-100" [appCdkScrollStickyTh]="viewport">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <tr>
                <th>Faktura Nr</th>
                <th>Dato</th>
                <th>BetDato</th>
                <th *ngIf="showClient">Kunde nr.</th>
                <th *ngIf="showClient">Kundenavn</th>
                <th class="text-end">Beløb</th>
                <th>Udskrevet</th>
                <th>E-mail</th>
                <th>Godkendt</th>
                <th>Godkendt af</th>
                <th *ngIf="markable">
                    <input
                        type="checkbox"
                        [checked]="allChecked"
                        (change)="onAllInvoiceMark($event.target.checked)"
                    >
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *cdkVirtualFor="let invoice of filteredInvoices; trackBy:trackByFnr" [class.kreditnota]="invoice.kreditnota">
                <td>
                    <span (click)="onInvoice(invoice.fnr, invoice.kid)" class="clickable--link">
                        {{ invoice.fakturanr }}
                    </span>
                </td>
                <td>{{ invoice.dato | date:'dd-MM-yyyy' }}</td>
                <td>{{ invoice.betdato | date:'dd-MM-yyyy' }}</td>
                <td *ngIf="showClient">{{ invoice.glkundenr }}</td>
                <td *ngIf="showClient">{{ invoice.kundenavn }}</td>
                <td class="text-end">{{ invoice.totalbel | currency:'DKK':'':'1.2-2':'da'}}</td>
                <td>{{ invoice.udskrevet | date:'dd-MM-yyyy' }}</td>
                <td><span [ngbTooltip]="invoice.sendmail">{{ invoice.maildate | date:'dd-MM-yyyy' }}</span></td>
                <td>{{ invoice.godkendt | date:'dd-MM-yyyy' }}</td>
                <td>{{ invoice.godkendtAf }}</td>
                <td *ngIf="markable">
                    <input
                        type="checkbox"
                        [disabled]="invoice.godkendt !== null"
                        [checked]="_markedInvoices.includes(invoice.fnr) && invoice.godkendt === null"
                        (change)="onInvoiceMark($event.target.checked, invoice.fnr)"
                    >
                </td>
            </tr>
        </tbody>
    </table>
</cdk-virtual-scroll-viewport>
